import { __extends } from "tslib";
import { Strategy, StrategyResolver } from '../resolvers/StrategyResolver';
import { RegistrationBuilderBase } from './RegistrationBuilderBase';
var TypeRegistrationBuilder = /** @class */ (function (_super) {
    __extends(TypeRegistrationBuilder, _super);
    function TypeRegistrationBuilder(container, type) {
        var _this = _super.call(this, container, new StrategyResolver(Strategy.Transient, type)) || this;
        _this.type = type;
        _this.instancePerDependency();
        return _this;
    }
    TypeRegistrationBuilder.prototype.singleInstance = function () {
        this.resolver.strategy = Strategy.Singleton;
        return this;
    };
    TypeRegistrationBuilder.prototype.instancePerScope = function () {
        this.resolver.strategy = Strategy.Scoped;
        return this;
    };
    TypeRegistrationBuilder.prototype.instancePerDependency = function () {
        this.resolver.strategy = Strategy.Transient;
        return this;
    };
    TypeRegistrationBuilder.prototype.asSelf = function () {
        this.as(this.type);
        return this;
    };
    return TypeRegistrationBuilder;
}(RegistrationBuilderBase));
export { TypeRegistrationBuilder };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHlwZVJlZ2lzdHJhdGlvbkJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJUeXBlUmVnaXN0cmF0aW9uQnVpbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQ0EsT0FBTyxFQUFFLFFBQVEsRUFBRSxnQkFBZ0IsRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBQzNFLE9BQU8sRUFBRSx1QkFBdUIsRUFBRSxNQUFNLDJCQUEyQixDQUFDO0FBRXBFO0lBQWdELDJDQUErQztJQUMzRixpQ0FBbUIsU0FBb0IsRUFBbUIsSUFBaUM7UUFBM0YsWUFDSSxrQkFBTSxTQUFTLEVBQUUsSUFBSSxnQkFBZ0IsQ0FBSSxRQUFRLENBQUMsU0FBUyxFQUFFLElBQUksQ0FBQyxDQUFDLFNBRXRFO1FBSHlELFVBQUksR0FBSixJQUFJLENBQTZCO1FBRXZGLEtBQUksQ0FBQyxxQkFBcUIsRUFBRSxDQUFDOztJQUNqQyxDQUFDO0lBRU0sZ0RBQWMsR0FBckI7UUFDSSxJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUMsU0FBUyxDQUFDO1FBRTVDLE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7SUFFTSxrREFBZ0IsR0FBdkI7UUFDSSxJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUMsTUFBTSxDQUFDO1FBRXpDLE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7SUFFTSx1REFBcUIsR0FBNUI7UUFDSSxJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUMsU0FBUyxDQUFDO1FBRTVDLE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7SUFFTSx3Q0FBTSxHQUFiO1FBQ0ksSUFBSSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7UUFFbkIsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztJQUNMLDhCQUFDO0FBQUQsQ0FBQyxBQTdCRCxDQUFnRCx1QkFBdUIsR0E2QnRFIn0=